import _noop from 'lodash/noop';

import { startLoading, stopLoading } from 'service/loader/action';
import request from 'utils/http';
import Apis from 'constants/api';

import { showError, showInfo, showSuccess, showWarning } from 'service/notifications/action';

import Icons from 'constants/icons';

import _get from 'lodash/get';
import actionType from './actionTypes';
import { createAssetRequestEngine } from '../blocdataexplorer/action';

export const getEventsByGroup = (groupRefId) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.event, {
            params: {
                groupRefId,
            },
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionType.GET_EVENTS_BY_GROUP_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsDown));
            dispatch(stopLoading());
        });
};

export const getAllTriggerEvents = (groupRefId) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.triggerEvent, {
            params: {
                groupRefId,
            },
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionType.GET_ALL_TRIGGER_EVENTS_SUCCESS,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch((error) => {
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsDown));
            dispatch(stopLoading());
        });
};

export const getEventsByGroupRefId = (groupRefId) =>
    request.get(Apis.refData.event, {
        params: {
            groupRefId,
        },
    });

export const createRefDataEvent =
    (payload = {}, groupRefId, handleModal = _noop) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .post(Apis.refData.event, payload)
            .then(({ data: { data } }) => {
                dispatch(stopLoading());
                dispatch(getEventsByGroup(groupRefId));
                dispatch(showSuccess(`Event created successfully`, Icons.thumbsUp));
                handleModal();
            })
            .catch(({ response }) => {
                const error = _get(response.data, 'error', null);
                if (error) {
                    const { message } = error;
                    dispatch(showError(message, Icons.thumbsDown));
                } else {
                    dispatch(showError('Unable to Copy Fields From Source, Invalid Input', Icons.thumbsDown));
                }
                dispatch(stopLoading());
            });
    };

export const createRefDataTriggerEvent =
    (payload, handleModal = _noop) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .post(Apis.refData.triggerEvent, payload)
            .then(({ data: { data } }) => {
                dispatch(stopLoading());
                dispatch(getAllTriggerEvents(payload.groupRefId));
                dispatch(showSuccess(`Event created successfully`, Icons.thumbsUp));
                handleModal();
            })
            .catch(({ response }) => {
                const error = _get(response.data, 'error', null);
                if (error) {
                    const { message } = error;
                    dispatch(showError(message, Icons.thumbsDown));
                }
                dispatch(stopLoading());
            });
    };

export const updateRefDataTriggerEvent =
    (payload = {}) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .put(Apis.refData.triggerEvent, payload)
            .then(({ data: { data } }) => {
                dispatch(stopLoading());
                dispatch(getAllTriggerEvents(payload.groupRefId));
                dispatch(showSuccess(`Event updated successfully`, Icons.thumbsUp));
            })
            .catch(({ response }) => {
                const error = _get(response.data, 'error', null);
                if (error) {
                    const { message } = error;
                    dispatch(showError(message, Icons.thumbsDown));
                } else {
                    dispatch(showError('Unable to Update Event', Icons.thumbsDown));
                }
                dispatch(stopLoading());
            });
    };

export const updateRefDataEvent =
    (payload = {}, groupRefId) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .put(Apis.refData.event, payload)
            .then(({ data: { data } }) => {
                dispatch(stopLoading());
                dispatch(getEventsByGroup(groupRefId));
                dispatch(showSuccess(`Event updated successfully`, Icons.thumbsUp));
            })
            .catch(({ response }) => {
                const error = _get(response.data, 'error', null);
                if (error) {
                    const { message } = error;
                    dispatch(showError(message, Icons.thumbsDown));
                } else {
                    dispatch(showError('Unable to Update Event', Icons.thumbsDown));
                }
                dispatch(stopLoading());
            });
    };

export const destroyEventInEngine = (eventId) => (dispatch) => {
    dispatch(startLoading());
    const endpoint = `${Apis.spring.match.triggerRefDataEvent}/${eventId}`;
    request
        .delete(endpoint)
        .then(({ data: { data } }) => {
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                dispatch(showError(message, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to Destory Event', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const destroyRefDataEvent =
    (payload = {}, groupRefId, resetEvent = _noop) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .delete(Apis.refData.event, {
                params: {
                    ...payload,
                },
            })
            .then(({ data: { data } }) => {
                dispatch(stopLoading());
                dispatch(destroyEventInEngine(payload.ref_id));
                dispatch(getEventsByGroup(groupRefId));
                dispatch(showSuccess(`Event deleted successfully`, Icons.thumbsUp));
                resetEvent();
            })
            .catch(({ response }) => {
                const error = _get(response.data, 'error', null);
                if (error) {
                    const { message } = error;
                    dispatch(showError(message, Icons.thumbsDown));
                } else {
                    dispatch(showError('Unable to Update Event', Icons.thumbsDown));
                }
                dispatch(stopLoading());
            });
    };

export const destroyRefDataTriggerEvent =
    (eventName, groupRefId, resetEvent = _noop) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .delete(Apis.refData.triggerEvent, {
                params: {
                    eventName,
                },
            })
            .then(({ data: { data } }) => {
                dispatch(stopLoading());
                dispatch(getAllTriggerEvents(groupRefId));
                dispatch(showSuccess(`Event deleted successfully`, Icons.thumbsUp));
                resetEvent();
            })
            .catch(({ response }) => {
                const error = _get(response.data, 'error', null);
                if (error) {
                    const { message } = error;
                    dispatch(showError(message, Icons.thumbsDown));
                } else {
                    dispatch(showError('Unable to Update Event', Icons.thumbsDown));
                }
                dispatch(stopLoading());
            });
    };

export const triggerEvent =
    (payload = {}, isNewRequest = false) =>
    (dispatch) => {
        dispatch(startLoading());
        if (isNewRequest) {
            dispatch(showInfo('Creating event schedule ', Icons.thumbsDown));
            request
                .post(Apis.spring.match.triggerRefDataEvent, payload)
                .then(({ data: { data } }) => {
                    dispatch(stopLoading());
                })
                .catch(({ response }) => {
                    const error = _get(response.data, 'error', null);
                    if (error) {
                        const { message = 'spring create failed' } = error;
                        dispatch(showError(message, Icons.thumbsDown));
                    } else {
                        dispatch(showError('Unable to create Event', Icons.thumbsDown));
                    }
                    dispatch(stopLoading());
                });
        } else {
            dispatch(showInfo('Updating event ', Icons.thumbsDown));
            const endpoint = `${Apis.spring.match.triggerRefDataEvent}/` + payload.eventId;
            request
                .put(endpoint, payload)
                .then(({ data: { data } }) => {
                    dispatch(stopLoading());
                })
                .catch(({ response }) => {
                    const error = _get(response.data, 'error', null);
                    if (error) {
                        const { message = 'spring update failed' } = error;
                        dispatch(showError(message, Icons.thumbsDown));
                    } else {
                        dispatch(showError('Unable to Update Event', Icons.thumbsDown));
                    }
                    dispatch(stopLoading());
                });
        }
    };

export const adHocEvent =
    (payload = []) =>
    (dispatch) => {
        request
            .post(Apis.spring.match.refDataEngineSimulate, payload)
            .then(({ data: { data } }) => {
                dispatch(showSuccess('Event triggered successfully', Icons.thumbsDown));
                dispatch(stopLoading());
            })
            .catch(({ response }) => {
                const error = _get(response.data, 'error', null);
                if (error) {
                    const { message = 'spring create failed' } = error;
                    dispatch(showError(message, Icons.thumbsDown));
                } else {
                    dispatch(showError('Unable to trigger the Event', Icons.thumbsDown));
                }
            });
    };

export const checkPermission =
    (payload = [], entitlementPayload) =>
    (dispatch) => {
        dispatch(startLoading());
        request
            .post(Apis.user.checkPermission, entitlementPayload)
            .then((response) => {
                if (response.data.hasPermission) {
                    if (entitlementPayload.operation === 'bd_eve_trigger') {
                        dispatch(adHocEvent(payload));
                    } else if (entitlementPayload.operation === 'bd_se_add') {
                        dispatch(createAssetRequestEngine(payload.payload, payload.explorerName));
                    }
                } else {
                    dispatch(showError('Permission Denied'));
                    dispatch(stopLoading());
                }
            })
            .catch((error) => {
                dispatch(showError('Permission check failed'));
                dispatch(stopLoading());
            });
    };

export const invalidEventName = () => showWarning(`Invalid Event Name Should Not be Empty`, Icons.thumbsDown);

export const getAllProcesses = (groupRefId, refDataEventProcessOrders) => (dispatch) => {
    dispatch(startLoading());
    request
        .post(Apis.refData.eventProcess, {
            groupRefId,
            refDataEventProcessOrders,
        })
        .then(({ data: { data } }) => {
            dispatch({
                type: actionType.GET_EVENT_PROCESSES,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                dispatch(showError(message, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to fetch the processes', Icons.thumbsDown));
            }
        });
};

export const getEventQueues = (groupRefId, eventRefId) => (dispatch) => {
    dispatch(startLoading());
    request
        .get(Apis.refData.eventProcessOrder, {
            params: {
                groupRefId,
                eventRefId,
            },
        })
        .then(({ data: { data } }) => {
            dispatch(showSuccess('Event Queues fetched successfully', Icons.thumbsUp));
            dispatch({
                type: actionType.GET_EVENT_PROCESSES_ORDER,
                payload: data,
            });
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                dispatch(showError(message, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to update Processing Order', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const updateRefDataProcessingOrders = (payload) => (dispatch) => {
    dispatch(startLoading());
    request
        .put(Apis.refData.eventProcessOrder, payload)
        .then(({ data: { data } }) => {
            dispatch(showSuccess('Processing Order Updated Successfully', Icons.thumbsUp));
            dispatch(getEventQueues(payload.groupRefId, payload.eventRefId));
            dispatch(stopLoading());
        })
        .catch(({ response }) => {
            const error = _get(response.data, 'error', null);
            if (error) {
                const { message } = error;
                dispatch(showError(message, Icons.thumbsDown));
            } else {
                dispatch(showError('Unable to update Processing Order', Icons.thumbsDown));
            }
            dispatch(stopLoading());
        });
};

export const getRefDataEventMonitoringRecords = (limit) => (dispatch) => {
    if (!limit) dispatch(startLoading());
    request
        .get(Apis.refData.eventMonitoring, {
            params: {
                limit,
            },
        })
        .then(({ data: { data } }) => {
            if (limit) {
                dispatch({
                    type: actionType.GET_REF_DATA_EVENT_WIDGET_DATA,
                    payload: data,
                });
            } else {
                dispatch({
                    type: actionType.GET_REF_DATA_EVENT_MONITORING_DATA,
                    payload: data,
                });
            }
            dispatch(stopLoading());
        })
        .catch((error) => {
            console.log(error);
            dispatch(showWarning(`Unable to Fetch Record's ,`, Icons.thumbsUp));
            dispatch(stopLoading());
        });
};

export const cleanEventMonitoringData = () => (dispatch) => {
    dispatch({
        type: actionType.GET_REF_DATA_EVENT_MONITORING_DATA,
        payload: { records: [], columns: [] },
    });
};

export const getEventImportRulesLockDetails = (eventMonitorId) =>
    request
        .get(Apis.refData.eventMonitoringRulesLock, {
            params: {
                eventMonitorId,
            },
        })
        .then(({ data: { data } }) => data)
        .catch(() => ({ columns: [], records: [] }));

export const getEventImportFileDetails = (eventMonitorId) =>
    request
        .get(Apis.refData.eventMonitoringFileDetails, {
            params: {
                eventMonitorId,
            },
        })
        .then(({ data: { data } }) => data)
        .catch(() => ({ columns: [], records: [] }));

export const getEventImportBatchDetails = (eventMonitorId, fileSeqId) =>
    request
        .get(Apis.refData.eventMonitoringBatchDetails, {
            params: {
                eventMonitorId,
                fileSeqId,
            },
        })
        .then(({ data: { data } }) => data)
        .catch(() => ({ columns: [], records: [] }));

export const processEvents = (payload) =>
    request
        .post(Apis.refData.processEventBatchFiles, payload)
        .then(({ data: { data } }) => data)
        .catch(() => ({
            columns: [],
            records: [],
        }));
